export default {
    confirm_user_username: 'Usuario',
    confirm_user_password: 'Contraseña',
    confirm_user_confirm_password: 'Confirmar Contraseña',
    confirm_user_confirm_user: 'Confirmar Usuario',
    confirm_user_required_filed: 'Campo requerido',
    confirm_user_forgot_password: '¿Ha olvidado su contraseña?',
    confirm_user_change_password: 'Cambiar Contraseña',
    confirm_user_sign_in_with_google: 'Acceder con Google',
    confirm_user_confirm_new_password: 'Confirmar Nueva Contraseña',
    page_not_found: 'Oops! Golpeamos un tope de velocidad',
    page_not_found_message: 'Parece que no se encuentra la página que está buscando. Si necesita que lo lleven a otro lugar, pruebe con uno de los botones de la izquierda',
    confirm_user_email: 'Correo Electrónico',
    confirm_user_confirm_password_error: 'Las contraseñas no coinciden',
    confirm_user_error: 'Error',
    confirm_user_confirm_password_sucess_message: 'Su contraseña ha sido cambiada con éxito. Ahora puede iniciar sesión con su nueva contraseña.',
    confirm_user_confirm_password_sucess_verify_message: 'Su usuario ha sido verificado con éxito. Ahora puede iniciar sesión con su nueva contraseña.',
    confirm_user_expired_code: 'Este enlace ha caducado. Comuníquese con su administrador para solicitar uno nuevo.',
    confirm_user_invalid_code: 'El código es inválido. Comuníquese con su administrador para solicitar uno nuevo.',
};